// <!-- Snowplow starts plowing - Standalone vE.2.14.0 -->
// BC Gov Snowplow loader, mirrored from dispute-cm-UI/src/core/utilities/rtb_analytics.js.

// Tracks whether the BC Gov Snowplow bootstrap has been installed for this page.
let snowplowInstalled = false;

// Lazily installs the standard Snowplow standalone loader. Kept out of the top-level
// module scope so that a disabled analytics config never loads the Snowplow SDK.
function installSnowplowLoader() {
  if (snowplowInstalled || (typeof window !== 'undefined' && window.snowplow)) return;

  snowplowInstalled = true;
  ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
    p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
  };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
  n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","https://www2.gov.bc.ca/StaticWebResources/static/sp/sp-2-14-0.js","snowplow"));
}

// Configure Snowplow for the target tracker URL passed in at startup.
function startPlowing(trackerUrl) {
  if (!trackerUrl) {
    console.warn('[Error] Unable to load RTB Analytics URL');
    return;
  }
  installSnowplowLoader();
  window.snowplow('newTracker', 'rt', trackerUrl, {
    appId: 'Snowplow_standalone_RTB',
    cookieLifetime: 86400 * 548,
    platform: 'web',
    post: true,
    forceSecureTracker: true,
    contexts: {
      webPage: true,
      performanceTiming: true,
    },
  });
  window.snowplow('enableActivityTracking', 30, 30); // Ping every 30 seconds after 30 seconds
  window.snowplow('enableLinkClickTracking');
  window.snowplow('trackPageView');
  // <!-- Snowplow stops plowing -->
}

export { startPlowing };